<template>
  <div>
    <label :for="name">{{ label }}</label>
    <div v-if="list.length" class="d-flex flex-wrap tw-border tw-border-border tw-rounded-sm mb-2">
      <div
        class="badge badge-secondary tw-bg-highlight-background m-1 d-flex flex-wrap tw-items-center !tw-text-highlight-text"
        v-for="(item, index) in list"
        :key="index"
      >
        {{ item }}
        <IconButton
          @click="removeFromList(index)"
          :icon="{ default: { icon: 'fa-regular fa-xmark' }, hover: { icon: 'fa-solid fa-xmark' } }"
          class="tw-text-[14px] tw-ml-1"
          :testId="`${testId}-${item.toLowerCase().replace(' ', '-')}-remove-icon-btn`"
        />
      </div>
    </div>
    <div class="tw-flex tw-items-center mb-2">
      <FormInput
        name="email"
        v-model="fields.email"
        :dirty="validation.fields.email.dirty"
        :disabled="loading"
        class="mb-0 me-2 w-100"
        :testId="`${testId}-cc-email-address-input`"
      />
      <Btn
        @click="addToList()"
        :disabled="!isSubmittable()"
        :variant="'primary'"
        :testId="`${testId}-add-cc-email-address-btn`"
      >
        Add
      </Btn>
    </div>
    <div
      class="invalid-feedback d-block mb-2"
      v-if="validation.fields.email.errors && validation.fields.email.errors.length"
    >
      <div v-for="(error, e) in validation.fields.email.errors" :key="e">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import Btn from "@/components/display/Btn";
import FormInput from "@/components/display/form/FormInput";
import FormMixin from "@/components/display/form/FormMixin";
import IconButton from "@/components/display/IconButton.vue";
import useValidator from "@/utils/useValidator";
import { validations } from "leatherman-js";

export default {
  name: "FormEmailListInput",
  components: {
    Btn,
    FormInput,
    IconButton,
  },
  mixins: [FormMixin],
  emits: ["input", "update:modelValue"],
  props: {
    testId: String,
    name: String,
    modelValue: Array,
    loading: Boolean,
  },
  setup(props, { emit }) {
    const fields = reactive({ email: null });
    const list = ref(props?.modelValue || []);
    const isValid = ref(false);

    const { validator } = useValidator();
    const validation = validator(
      fields,
      validations.forms.email,
      {},
      {
        email: {
          email: "Invalid Email",
        },
      }
    );

    const isSubmittable = () => fields?.email?.length > 0 && validation.errors.length === 0;

    const addToList = () => {
      if (!list.value.includes(fields.email)) {
        list.value.push(fields.email);
      }

      fields.email = "";
      emit("input", list.value);
      emit("update:modelValue", list.value);
    };

    const removeFromList = (index) => {
      list.value.splice(index, 1);
    };

    return {
      addToList,
      fields,
      isSubmittable,
      isValid,
      list,
      removeFromList,
      validation,
    };
  },
};
</script>
